const percentageRangeErrors = (
  value: number,
  label: string,
): string[] | undefined => {
  if (!Number.isFinite(value)) {
    return [`The ${label} must be a number`];
  }
  if (value < 0) {
    return [`The ${label} must be at least 0`];
  }
  if (value > 100) {
    return [`The ${label} must be 100 or less`];
  }
  return undefined;
};

export const requiredPercentageErrors = (
  value: number | null | undefined,
  label: string,
): string[] | undefined => {
  if (!value && value !== 0) {
    return [`The ${label} is required`];
  }
  return percentageRangeErrors(value, label);
};

export const optionalPercentageErrors = (
  value: number | null | undefined,
  label: string,
): string[] | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }
  return percentageRangeErrors(value, label);
};

export const requiredPositivePercentageErrors = (
  value: number | null | undefined,
  label: string,
): string[] | undefined => {
  if (value === null || value === undefined) {
    return [`The ${label} is required`];
  }
  if (value <= 0) {
    return [`The ${label} must be greater than 0`];
  }
  return percentageRangeErrors(value, label);
};

export default requiredPercentageErrors;
